import React from "react";
import styles from "./BotPerformance.module.scss";
import RemainingTokens from "./remaining-tokens/RemainingTokens";
import ResolutionRate from "./resolution-rate/ResolutionRate";
import UserSatisfactionRate from "./user-satisfaction-rate/UserSatisfactionRate";
import MostUsedWorkflow from "./most-used-workflow/MostUsedWorkflow";
import MostUsedKnowledgeBase from "./most-used-knowledge-base/MostUsedKnowledgeBase";

const BotPerformance = ({ botId, startDate, endDate }) => {
  return (
    <div className={styles["bot-performance-container"]}>
      <div className={styles["insights-container"]}>
        <RemainingTokens botId={botId} />

        <div data-export="resolution-rate">
          <ResolutionRate
            botId={botId}
            startDate={startDate}
            endDate={endDate}
          />
        </div>

        <div data-export="user-satisfaction-rate">
          <UserSatisfactionRate
            botId={botId}
            startDate={startDate}
            endDate={endDate}
          />
        </div>
      </div>

      <div className={styles["usage-container"]}>
        <MostUsedWorkflow id={botId} startDate={startDate} endDate={endDate} />
        <MostUsedKnowledgeBase
          id={botId}
          startDate={startDate}
          endDate={endDate}
        />
      </div>
    </div>
  );
};

export default BotPerformance;
